import {FC} from 'react';
import {twMerge} from 'tailwind-merge';
import {Currency} from 'types';
import {toCurrency} from 'utils/number';

export type CurrencyValueProps = {
    className?: string;
    currency: Currency;
    disabled?: boolean;
    value: bigint | number;
};

const CurrencyValue: FC<CurrencyValueProps> = ({
    className,
    currency,
    disabled,
    value,
}) => (
    <div className={twMerge(disabled && 'text-light-disabled', className)}>
        {toCurrency({currency, value})}
    </div>
);

export default CurrencyValue;
